import styled, { css, DefaultTheme } from 'styled-components';
import { ANIMATION_CURVE, ANIMATION_DURATION, getSpacingToken, getToken, SpacingToken } from '@optimus-web/common';
import { BareIconButton } from '../BareIconButton';
import { DEFAULT_ACCORDION_SPACING } from './constants';

export const AccordionContainerElement = styled.div`
    text-align: left;
`;

interface AccordionHeaderElementProps {
    withHeaderBorder?: boolean;
    headerPadding: { top: SpacingToken; bottom: SpacingToken; left: SpacingToken; right: SpacingToken };
}

const getPaddingValue = (value: SpacingToken, theme: DefaultTheme) => `${getSpacingToken(`${value}`)({ theme })}px`;

export const AccordionHeaderElement = styled.div<AccordionHeaderElementProps>`
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: ${getSpacingToken(`${DEFAULT_ACCORDION_SPACING}`)}px;
    padding: ${({ headerPadding: { top, right, bottom, left }, theme }) => {
        const topPadding = getPaddingValue(top, theme);
        const rightPadding = getPaddingValue(right, theme);
        const bottomPadding = getPaddingValue(bottom, theme);
        const leftPadding = getPaddingValue(left, theme);

        return `${topPadding} ${rightPadding} ${bottomPadding} ${leftPadding}`;
    }};
    padding-bottom: ${({ headerPadding }) => getSpacingToken(`${headerPadding.bottom}`)}px;
    background-color: ${getToken('backgroundStaticFlat')};
    ${({ withHeaderBorder }) =>
        withHeaderBorder &&
        css`
            border-bottom: ${getToken('borderWidth100')}px solid ${getToken('borderStaticPrimary')};
        `}
    cursor: pointer;
`;

export const AccordionHeaderLeftElement = styled.div`
    display: flex;
    cursor: default;
    align-items: center;
    gap: ${getSpacingToken(`${DEFAULT_ACCORDION_SPACING}`)}px;
`;

export const AccordionHeaderLabelElement = styled.div`
    display: flex;
    gap: ${getSpacingToken(`${DEFAULT_ACCORDION_SPACING}`)}px;
    align-items: center;
    flex: 1;
    flex-wrap: wrap;
`;

export const AccordionHeaderRightElement = styled.div`
    display: flex;
    cursor: default;
    align-items: center;
`;
export interface AccordionIconProps {
    expanded: boolean;
}

export const AccordionIconButtonElement = styled(BareIconButton)<AccordionIconProps>`
    & > span {
        transform: ${({ expanded }) => (expanded ? 'rotate(180deg)' : 'none')};
        transition-timing-function: ${ANIMATION_CURVE.default};
        transition-duration: ${ANIMATION_DURATION.fast}ms;
    }
`;

export interface AccordionBodyProps {
    bodyPadding: SpacingToken;
    withBodyBorder?: boolean;
}

export const AccordionBodyElement = styled.div<AccordionBodyProps>`
    background-color: ${getToken('backgroundStaticFlat')};
    ${({ bodyPadding }) => css`
        padding: ${getSpacingToken(`${bodyPadding}`)}px;
    `}
    ${({ withBodyBorder }) =>
        withBodyBorder &&
        css`
            border-bottom: ${getToken('borderWidth100')}px solid ${getToken('borderStaticPrimary')};
        `}
`;
